import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import dayjs from "dayjs";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { FuncionarioAprovador } from "../../../../domain/models/funcionario_aprovador";

/**
 * GenerateFuncionariosAprovadoresColumns
 */

type Props = {
  onActionDeletar: (idFuncionarioAprovador: number, openState: boolean) => void;
  onActionEditar: (aprovador: FuncionarioAprovador) => void;
};

export const GenerateFuncionariosAprovadoresColumns = ({
  onActionDeletar,
  onActionEditar,
}: Props): GridColDef[] => {
  return [
    {
      field: "nomeFuncionario",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "emailFuncionario",
      filterable: false,
      headerName: "E-Mail",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "valorMaximo",
      filterable: false,
      headerName: "Valor máximo",
      width: 160,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value == null ? 'Sem limite' : value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        );
      }
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data de Cadastro",
      width: 100,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value && dayjs(value).utc().local().format('DD/MM/YYYY')}
          </div>
        );
      }
    },
    {
      field: 'idFuncionarioAprovador',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value, row }) => {
        return (
          <div className="w-full h-full flex items-center justify-center gap-0">
            <IconButton aria-label="Editar aprovador" onClick={() => onActionEditar(row)}>
              <DynamicIcon nameIcon="EditRounded" size={20} className="text-primary-green" />
            </IconButton>
            <IconButton
              onClick={() => { onActionDeletar(value, true) }}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={20}
                className={'text-red-500'}
              />
            </IconButton>
          </div>
        );
      }
    },
  ];
}
